<template>
  <div class="new-contract-manage-container">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>合同查询</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
              v-model.trim="searchForm.partyBName"
              placeholder="客户名称"
              clearable
          />
        </el-col>
        <el-col :span="6">
          <el-input
              v-model.trim="searchForm.contractId"
              placeholder="合同ID"
              clearable
          />
        </el-col>
        <el-col :span="6">
          <el-select
              v-model="searchForm.templateCode"
              placeholder="请选择合同来源"
              clearable
              style="width: 100%"
          >
            <el-option
                label="房屋租赁协议模板（装修抵租金.不含采暖费版本）"
                value="houseRent"
            ></el-option>
            <el-option
                label="光谷房屋租赁协议最新版本"
                value="houseRentNew"
            ></el-option>
            <el-option
                label="房屋租赁协议模板（终版.含采暖费）"
                value="houseRentHeating"
            ></el-option>
            <el-option
                label="房屋租赁协议模板（终版.不含采暖费版本）"
                value="houseRentNotHeating"
            ></el-option>
          </el-select>
        </el-col>
        <!-- 新增：负责人选择搜索 -->
        <el-col :span="6">
          <el-select
              v-model="searchForm.contractManager"
              placeholder="请选择负责人"
              clearable
              filterable
              remote
              :remote-method="remoteSearchStaff"
              :loading="loadingStaff"
              style="width: 100%"
          >
            <el-option
                v-for="staff in staffList"
                :key="staff.userId"
                :label="staff.name"
                :value="staff.userId"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 5px">
        <!-- 创建时间范围 -->
        <el-col :span="6">
          <el-date-picker
              v-model="searchForm.createTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始创建时间"
              end-placeholder="结束创建时间"
              value-format="yyyy-MM-dd"
              style="width: 100%"
          />
        </el-col>

        <!-- 楼栋下拉 -->
        <el-col :span="6">
          <el-select
              v-model="searchForm.floorId"
              placeholder="请选择楼栋"
              clearable
              filterable
              style="width: 100%"
          >
            <el-option
                v-for="floor in floorList"
                :key="floor.floorId"
                :label="`${floor.floorNum}栋(${floor.floorName})`"
                :value="floor.floorId"
            />
          </el-select>
        </el-col>

        <!-- 房间号（保留） -->
        <el-col :span="6">
          <el-input
              v-model.trim="searchForm.selectedHouse"
              placeholder="房间号"
              clearable
          />
        </el-col>
        <!-- 新增：是否退租下拉 -->
        <el-col :span="6">
          <el-select
              v-model="searchForm.state"
              placeholder="是否退租"
              clearable
              style="width: 100%"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="已退租" value="Q"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 5px">
        <el-col :span="10">
          <el-button type="primary" @click="handleSearch">
            <i class="el-icon-search"></i>
            查询
          </el-button>
          <el-button @click="handleReset">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
          <el-button
              type="primary"
              @click="openContractModal"
              :disabled="isSaving"
          >
            生成合同
          </el-button>
          <!-- 新增：导出Excel按钮 -->
          <el-button
              type="success"
              @click="exportExcel"
              icon="el-icon-download"
          >
            导出Excel
          </el-button>
          <el-button
              type="primary"
              icon="el-icon-download"
              @click="batchDownloadAttach"
          >
            批量下载附件
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 合同列表 -->
    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <span>合同列表</span>
      </div>

      <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          ref="multipleTable"
      >
        <!-- 新增多选框列 -->
        <el-table-column type="selection" width="55" align="center" />

        <!-- 乙方名称 -->
        <el-table-column
            prop="partyBName"
            label="企业名称"
            align="center"
            min-width="120"
        />
        <!-- 房屋名称列：修改为可点击，超出隐藏 -->
        <el-table-column label="房屋号" align="center" min-width="120">
          <template slot-scope="scope">
            <span
                class="house-name-text"
                @click="openHouseNameModal(scope.row.houseName)"
                :title="scope.row.houseName"
            >
              {{ scope.row.houseName || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="houseArea"
            label="签约面积"
            align="center"
            min-width="120"
        />
        <el-table-column
            prop="moonTotals"
            label="年租金"
            align="center"
            min-width="120"
        />
        <el-table-column
            prop="totals"
            label="签约额"
            align="center"
            min-width="120"
        />
        <el-table-column
            prop="startTime"
            label="起租日期"
            align="center"
            min-width="180"
        />
        <el-table-column
            prop="endTime"
            label="到期日期"
            align="center"
            min-width="180"
        />
        <el-table-column
            prop="marginDeposit"
            label="保证金"
            align="center"
            min-width="180"
        />
        <el-table-column
            prop="paymentMarginDeposit"
            label="保证金缴费金额"
            align="center"
            min-width="150"
        />
        <el-table-column
            prop="paymentMarginDepositTime"
            label="保证金缴费时间"
            align="center"
            min-width="150"
        />
        <!-- 新增：负责人列 -->
        <el-table-column label="责任人" align="center" min-width="120">
          <template slot-scope="scope">
            {{ getStaffName(scope.row.rawData.contractManager) }}
          </template>
        </el-table-column>
        <el-table-column
            prop="signDate"
            label="签订日期"
            align="center"
            min-width="150"
        />
        <el-table-column
            prop="policyInfo"
            label="政策信息"
            align="center"
            min-width="150"
        />
        <!-- 新增：是否退租展示列 -->
        <el-table-column label="是否退租" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.state === "Q" ? "已退租" : "正常" }}
          </template>
        </el-table-column>

        <el-table-column label="是否开具印花税" align="center" width="120">
          <template slot-scope="scope">
            <el-switch
                :value="scope.row.stampDutyStatus"
                active-value="1"
                inactive-value="0"
                active-text="是"
                inactive-text="否"
                @click.native="handlestampDutyStatusChange(scope.row)"
            />
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" align="center" width="600">
          <!-- 加宽列宽 -->
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">
              查看费用
            </el-button>
            <el-button
                v-if="hasPrivilege('502021033186520392')"
                size="mini"
                type="primary"
                @click="openEditContractModal(scope.row)"
            >
              编辑合同
            </el-button>
            <el-button
                size="mini"
                type="primary"
                @click="downloadContract(scope.row)"
            >
              下载合同
            </el-button>
            <!-- 上传附件按钮 -->
            <template>
              <!-- 无附件：显示【上传附件】按钮 -->
              <el-button
                  v-if="
                  !scope.row.rawData.filePath ||
                  scope.row.rawData.filePath.trim() === ''
                "
                  size="mini"
                  type="success"
                  icon="el-icon-upload2"
                  @click="openUploadModal(scope.row)"
              >
                上传附件
              </el-button>

              <!-- 已有附件：显示【已上传附件】按钮，可点击预览/重新上传 -->
              <el-button
                  v-else
                  size="mini"
                  type="primary"
                  icon="el-icon-document"
                  @click="openUploadModal(scope.row)"
              >
                已上传附件
              </el-button>
            </template>
            <!-- 新增：退租按钮 -->
            <!-- 示例：仅state为"normal"或空时显示 -->
            <el-button
                size="mini"
                type="warning"
                icon="el-icon-circle-close"
                @click="openQuitRentModal(scope.row)"
                v-if="!scope.row.state"
            >
              退租
            </el-button>
            <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          :current-page="pagination.current"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 合同弹窗组件 -->
    <contract-modal ref="contractModal" @success="fetchData" />

    <!-- 上传附件弹窗：修改后增加确定按钮调用接口逻辑 -->
    <el-dialog
        title="上传合同附件"
        :visible.sync="uploadModalVisible"
        width="500px"
        destroy-on-close
        :before-close="handleDialogClose"
    >
      <el-upload
          class="upload-demo"
          drag
          action="/callComponent/upload/uploadFile/uploadImage"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
          :limit="1"
          name="uploadFile"
          :data="uploadExtraParams"
          :file-list="fileList"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemove"
          :auto-upload="true"
          :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          支持 PDF, Word, Excel, PPT (单个文件最大 10MB)
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadModalVisible = false">取消</el-button>
        <el-button
            type="primary"
            @click="handleConfirmUpload"
            :loading="uploadConfirmLoading"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑合同弹窗：表格展示详情数据 -->
    <el-dialog
        title="编辑合同信息"
        :visible.sync="editModalVisible"
        width="800px"
        :close-on-click-modal="false"
        destroy-on-close
    >
      <!-- 合同基础信息 -->
      <el-card class="edit-base-card" shadow="never">
        <div slot="header">合同基础信息</div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="info-item">
              <span class="label">合同编号：</span>
              <span class="value">{{ editForm.contractId || "无" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">合同来源：</span>
              <span class="value">{{ editForm.contractTypeName || "无" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">总金额：</span>
              <span class="value"
              >{{ Number(editForm.totalAmount).toFixed(2) }} 元</span
              >
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">签订日期：</span>
              <span class="value">{{ editForm.signDate || "无" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">乙方名称：</span>
              <span class="value">{{ editForm.partyBName || "无" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">乙方电话：</span>
              <span class="value">{{ editForm.partyBPhone || "无" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">负责人：</span>
              <span class="value">{{
                  getStaffName(editForm.contractManager) || "无"
                }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- ========== 新增独立保证金表格区域 ========== -->
      <el-card class="deposit-card" shadow="never" style="margin-top:15px">
        <div slot="header">保证金信息</div>
        <el-table
            :data="depositTableData"
            border
            style="width:100%"
            size="mini"
        >
          <el-table-column label="应收保证金(元)" align="center">
            <template slot-scope="scope">
              {{ scope.row.marginDeposit ? Number(scope.row.marginDeposit).toFixed(2) : "0.00" }}
            </template>
          </el-table-column>
          <el-table-column label="保证金缴费金额(元)" align="center">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.paymentMarginDeposit"
                  size="mini"
                  :min="0"
                  :step="0.01"
                  :precision="2"
              />
            </template>
          </el-table-column>
          <el-table-column label="保证金缴费时间" align="center" min-width="220">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.paymentMarginDepositTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择缴费时间"
                  size="mini"
              />
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:12px;text-align:right">
          <el-button
              type="primary"
              size="mini"
              :loading="saveDepositLoading"
              @click="handleSaveDeposit"
          >
            确认保存保证金
          </el-button>
        </div>
      </el-card>

      <!-- 合同付款详情 -->
      <el-card class="edit-table-card" shadow="never" style="margin-top: 15px">
        <div slot="header">合同付款详情</div>
        <el-table
            v-loading="editLoading"
            :data="editTableData"
            border
            style="width: 100%"
            size="mini"
        >
          <el-table-column
              prop="paymentNo"
              label="付款序号"
              align="center"
              width="80"
          />
          <el-table-column prop="paymentDate" label="付款日期" align="center" />

          <!-- 新增：房租 rentOnlyAmount -->
          <el-table-column label="房租" align="center" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.rentOnlyAmount
                    ? Number(scope.row.rentOnlyAmount).toFixed(2)
                    : "0.00"
              }}
            </template>
          </el-table-column>
          <!-- 新增：采暖 heatingOnlyAmount -->
          <el-table-column label="采暖费" align="center" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.heatingOnlyAmount
                    ? Number(scope.row.heatingOnlyAmount).toFixed(2)
                    : "0.00"
              }}
            </template>
          </el-table-column>

          <!-- 可编辑：缴费金额 paymentAmount -->
          <el-table-column
              prop="rentalDays"
              label="计租天数"
              align="center"
              width="80"
          />
          <el-table-column
              prop="rentAmount"
              label="租金金额(元)"
              align="center"
              :formatter="(row) => row.rentAmount.toFixed(2)"
          />

          <el-table-column label="缴费金额" align="center" min-width="150">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.paymentAmount"
                  size="mini"
                  :min="0"
                  :step="0.01"
                  :precision="2"
                  @change="handlePaymentAmountChange(scope.row)"
              />
            </template>
          </el-table-column>

          <!-- 可编辑：缴费时间 paymentAmountTime -->
          <el-table-column label="缴费时间" align="center" min-width="250">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.paymentAmountTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择缴费时间"
                  size="mini"
                  @change="handlePaymentTimeChange(scope.row)"
              />
            </template>
          </el-table-column>

          <!-- ====================== 你要的 4 个开关 放这里 ====================== -->
          <el-table-column label="是否开具发票" align="center" width="130">
            <template slot-scope="scope">
              <el-switch
                  :value="scope.row.invoiceStatus"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @click.native="handleInvoiceChange(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="是否预开发票" align="center" width="130">
            <template slot-scope="scope">
              <el-switch
                  :value="scope.row.preInvoiceStatus"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @click.native="handlePreInvoiceChange(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="是否上缴" align="center" width="120">
            <template slot-scope="scope">
              <el-switch
                  :value="scope.row.isPayStatus"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                  @click.native="handlePayStatusChange(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-card>



      <!-- 弹窗底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModalVisible = false">确认</el-button>
      </div>
    </el-dialog>

    <!-- 房屋名称详情弹窗 -->
    <el-dialog
        title="房屋名称详情"
        :visible.sync="houseNameModalVisible"
        width="400px"
        destroy-on-close
        center
    >
      <div class="house-name-content">
        {{ houseNameFullText || "无" }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="houseNameModalVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增：退租弹窗 -->
    <!-- 新增：退租弹窗 -->
    <el-dialog
        title="合同退租处理"
        :visible.sync="quitRentModalVisible"
        width="500px"
        destroy-on-close
        :before-close="handleQuitRentDialogClose"
    >
      <el-form
          ref="quitRentFormRef"
          :model="quitRentForm"
          :rules="quitRentRules"
          label-width="100px"
      >
        <el-form-item label="退租日期" prop="quitRentDate">
          <el-date-picker
              v-model="quitRentForm.quitRentDate"
              type="date"
              placeholder="请选择退租日期"
              value-format="yyyy-MM-dd"
              style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="退租说明" prop="quitRentDesc">
          <el-input
              v-model="quitRentForm.quitRentDesc"
              type="textarea"
              placeholder="请输入退租说明（选填）"
              :rows="3"
          />
        </el-form-item>
        <!-- 改为绑定 prop，支持必填校验 -->
        <el-form-item label="退租附件" prop="quitRentFilePath">
          <el-upload
              class="upload-demo"
              drag
              action="/callComponent/upload/uploadFile/uploadImage"
              accept=".pdf,.doc,.docx,.jpg,.png,.xls,.xlsx"
              :limit="1"
              name="uploadFile"
              :data="quitRentUploadParams"
              :file-list="quitRentFileList"
              :on-success="handleQuitRentUploadSuccess"
              :on-remove="handleQuitRentRemove"
              :auto-upload="true"
              :on-exceed="handleQuitRentExceed"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持 PDF、Word、图片、Excel (单个文件最大 10MB)
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quitRentModalVisible = false">取消</el-button>
        <el-button
            type="primary"
            @click="handleConfirmQuitRent"
            :loading="quitRentConfirmLoading"
        >
          确认退租
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryContractNew,
  QueryPaymentsByContractCmd,
  uploadContractAttachmentRel, // 附件关联接口
  getStaffInfos, // 负责人列表接口
  queryFloorAndUnits,
  exportContractExcel, // 新增：导出Excel接口（需要你根据实际接口名调整）
  quitRentContract, // 新增：退租接口（需替换为实际接口名）
  updateContractNew,
  updatePaymentsByContract,
  deleteContractNew,
} from "@/api/contract/newContractManageApi";
import { getCommunityId } from "@/api/community/communityApi";
import ContractModal from "@/components/contract/contractModal";

// 模板编码与合同类型名的映射
const TEMPLATE_CODE_MAP = {
  houseRent: "房屋租赁协议模板（装修抵租金.不含采暖费版本）",
  houseRentNotHeating: "房屋租赁协议模板（终版.不含采暖费版本）",
  houseRentNew: "光谷房屋租赁协议最新版本",
  houseRentHeating: "房屋租赁协议模板（终版.含采暖费）",
};

export default {
  name: "NewContractManageList",
  components: {
    ContractModal,
  },
  data() {
    return {
      componentDestroyed: false,
      uploadExtraParams: {
        communityId: this.communityId,
      },
      loading: false,
      searchForm: {
        partyBName: "",
        contractId: "",
        templateCode: "",
        contractManager: "",
        floorId: "", // 新增：楼栋ID
        selectedHouse: "", // 房间号（已存在）
        createTimeRange: [], // 新增：创建时间范围 [start, end]
        state: "", // 新增：是否退租 空=全部 Q=已退租
      },
      floorList: [], // 楼栋列表
      loadingFloor: false, // 楼栋加载状态（可选）
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      communityId: "",
      isSaving: false,
      // 上传附件相关【修改：新增uploadFileName存储文件名】
      uploadModalVisible: false,
      uploadForm: {
        contractId: "", // 合同ID
      },
      fileList: [],
      uploadFilePath: "", // 存储文件上传后的路径
      uploadFileName: "", // 新增：原始文件名
      uploadConfirmLoading: false, // 确定按钮加载状态
      depositTableData:[],
      // 编辑合同相关
      editModalVisible: false,
      editLoading: false,
      editSaving: false,
      editForm: {
        contractId: "",
        contractTypeName: "",
        totalAmount: 0,
        signDate: "",
        partyBName: "",
        partyBPhone: "",
        contractManager: "", // 负责人ID
      },
      editTableData: [],

      // 新增：负责人相关
      staffList: [], // 负责人列表
      loadingStaff: false, // 负责人加载状态

      // 房屋名称弹窗相关
      houseNameModalVisible: false, // 弹窗显示状态
      houseNameFullText: "", // 房屋名称完整文本

      // 导出相关
      exportLoading: false, // 导出按钮加载状态

      // 新增：退租相关【同步增加退租附件文件名】
      quitRentModalVisible: false,
      quitRentForm: {
        contractId: "", // 合同ID
        quitRentDate: "", // 退租日期
        quitRentDesc: "", // 退租说明
        quitRentFilePath: "", // 退租附件路径
        quitRentFileName: "", // 新增：退租附件原始文件名
      },
      quitRentRules: {
        quitRentDate: [
          { required: true, message: "请选择退租日期", trigger: "change" },
        ],
        quitRentFilePath: [
          { required: true, message: "请上传退租附件", trigger: "change" },
        ],
      },
      quitRentFileList: [],
      quitRentUploadParams: {
        communityId: this.communityId,
      },
      quitRentConfirmLoading: false,

      // ========== 新增批量下载多选数组 ==========
      multipleSelection: [],
    };
  },
  created() {
    this.communityId = getCommunityId();
    this.loadFloorList(); // 先加载楼栋
    this.fetchData();
    this.loadStaffList(); // 初始化加载负责人列表
    // 更新退租上传参数的社区ID
    this.quitRentUploadParams.communityId = this.communityId;
  },
  beforeDestroy() {
    this.componentDestroyed = true;
  },
  methods: {
    // ========== 新增多选事件 ==========
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 修改缴费金额
    async handlePaymentAmountChange(row) {
      try {
        const params = {
          paymentId: row.paymentId,
          paymentAmount: row.paymentAmount,
        };
        const res = await updatePaymentsByContract(params);
        if (res.code === 0) {
          this.$message.success("缴费金额修改成功");
        } else {
          this.$message.error(res.msg || "修改失败");
        }
      } catch (err) {
        console.error("修改缴费金额报错：", err);
        this.$message.error("请求异常，修改失败");
      }
    },

    // 修改缴费时间
    async handlePaymentTimeChange(row) {
      try {
        const params = {
          paymentId: row.paymentId,
          paymentAmountTime: row.paymentAmountTime,
        };
        const res = await updatePaymentsByContract(params);
        if (res.code === 0) {
          this.$message.success("缴费时间修改成功");
        } else {
          this.$message.error(res.msg || "修改失败");
        }
      } catch (err) {
        console.error("修改缴费时间报错：", err);
        this.$message.error("请求异常，修改失败");
      }
    },

    async handleDelete(row) {
      const contractId = row.contractId;
      this.$confirm(
        `确定要删除合同【${contractId}】吗？删除后数据无法恢复！`,
        "删除确认",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "取消",
          type: "error",
        },
      )
        .then(async () => {
          try {
            // POST请求，传contractId
            const res = await deleteContractNew({ contractId });
            if (res.code === 0) {
              this.$message.success("删除成功");
              this.fetchData(); // 刷新列表
            } else {
              this.$message.error(res.msg || "删除失败");
            }
          } catch (err) {
            console.error("删除接口报错：", err);
            this.$message.error("删除请求异常，请重试");
          }
        })
        .catch(() => {
          // 取消删除，无操作
        });
    },

    // ========== 新增批量下载附件核心方法 ==========
    async batchDownloadAttach() {
      // 1. 判断是否勾选
      if (!this.multipleSelection.length) {
        this.$message.warning("请先勾选需要下载附件的合同");
        return;
      }
      // 2. 过滤存在附件的数据
      const hasAttachList = this.multipleSelection.filter(
        (item) => item.rawData.filePath,
      );
      const noAttachCount =
        this.multipleSelection.length - hasAttachList.length;
      if (!hasAttachList.length) {
        this.$message.warning("勾选的数据均无附件可下载");
        return;
      }
      // 提示有无附件条目
      if (noAttachCount > 0) {
        this.$message.info(
          `共勾选${this.multipleSelection.length}条，其中${noAttachCount}条无附件，仅下载存在附件的${hasAttachList.length}条`,
        );
      }
      // 3. 循环批量下载
      for (const row of hasAttachList) {
        const { filePath, fileName } = row.rawData;
        await this.downloadFile(filePath, fileName);
        // 间隔300ms防止浏览器拦截批量下载
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
      this.$message.success("批量下载完成");
      // 清空选中
      this.$refs.multipleTable.clearSelection();
    },

    // ========== 通用下载文件方法（url+自定义文件名） ==========
    // 通用下载：Blob方式强制自定义文件名，fileName为空则使用原URL文件名
    async downloadFile(url, fileName) {
      try {
        const res = await fetch(url, {
          mode: "cors",
        });
        const blob = await res.blob();
        const a = document.createElement("a");
        const blobUrl = URL.createObjectURL(blob);
        a.href = blobUrl;
        // 有fileName就用，没有自动截取url末尾文件名
        if (fileName) {
          a.download = fileName;
        } else {
          // 截取链接末尾文件原名
          const urlArr = url.split("/");
          a.download = urlArr[urlArr.length - 1];
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      } catch (err) {
        // 跨域/请求失败降级为原a标签下载
        const a = document.createElement("a");
        a.href = url;
        if (fileName) a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },

    // 新增：加载负责人列表
    async loadStaffList() {
      if (this.staffList.length > 0) return;
      this.loadingStaff = true;
      try {
        const res = await getStaffInfos({ page: 1, row: 1000 });
        this.staffList = res.staffs || [];
        if (this.staffList.length === 0) {
          this.$message.warning("未查询到负责人数据");
        }
      } catch (error) {
        console.error("加载负责人失败：", error);
        this.$message.error("加载负责人失败，请重试");
        this.staffList = [];
      } finally {
        this.loadingStaff = false;
      }
    },
    async loadFloorList() {
      this.loadingFloor = true;
      try {
        const res = await queryFloorAndUnits({
          communityId: this.communityId,
          page: 1,
          row: 1000,
        });
        // 去重：因为同一个 floorId 可能有多个 unit，但楼栋只需显示一次
        const uniqueFloors = Array.from(
          new Map(res.data.map((item) => [item.floorId, item])).values(),
        );
        this.floorList = uniqueFloors;
      } catch (error) {
        console.error("加载楼栋失败：", error);
        this.$message.error("加载楼栋信息失败");
        this.floorList = [];
      } finally {
        this.loadingFloor = false;
      }
    },

    openEditContractModal(row) {
      const contractId = row.rawData.contractId;
      if (!contractId) {
        this.$message.warning("未获取到合同ID，无法编辑");
        return;
      }
      // 调用子组件open方法，传入contractId
      this.$refs.contractModal.open(contractId);
    },
    downloadContract(row) {
      const contractWordBase = row.rawData.contractWordBase; // 从 rawData 获取 base64
      if (!contractWordBase) {
        this.$message.warning("未找到合同文件，请联系管理员");
        return;
      }

      // 构造文件名：例如：9de39b..._房屋租赁合同.docx
      const contractName = row.contractTypeName || "合同";
      const fileName = `${contractName}.docx`;

      // Base64 解码为 Blob
      const byteCharacters = atob(contractWordBase); // 解码 Base64
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    // 新增：远程搜索负责人
    async remoteSearchStaff(query) {
      if (!query) {
        this.loadStaffList(); // 无搜索词时加载全部
        return;
      }
      this.loadingStaff = true;
      try {
        // 带搜索词查询负责人（若接口支持，否则前端过滤）
        const res = await getStaffInfos({ page: 1, row: 1000, name: query });
        this.staffList = res.staffs || [];
      } catch (error) {
        console.error("搜索负责人失败：", error);
        this.$message.error("搜索负责人失败，请重试");
        this.staffList = [];
      } finally {
        this.loadingStaff = false;
      }
    },

    // 新增：根据负责人ID获取姓名
    getStaffName(staffId) {
      if (!staffId) return "无";
      const staff = this.staffList.find((item) => item.userId === staffId);
      return staff ? staff.name : "未知";
    },

    // 打开房屋名称弹窗
    openHouseNameModal(fullText) {
      // 将逗号分隔的名称转为换行显示（可选优化）
      this.houseNameFullText = fullText ? fullText.replace(/,/g, "\n") : "无";
      this.houseNameModalVisible = true;
    },

    // 获取合同列表 --- 核心修改：拆解时间区间参数
    async fetchData() {
      try {
        this.loading = true;
        // 你原来所有逻辑不变
        const [createTimeStart, createTimeEnd] =
          this.searchForm.createTimeRange || [];
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          partyBName: this.searchForm.partyBName,
          contractId: this.searchForm.contractId,
          templateCode: this.searchForm.templateCode,
          contractManager: this.searchForm.contractManager,
          floorId: this.searchForm.floorId,
          selectedHouse: this.searchForm.selectedHouse,
          state: this.searchForm.state,
          startSignDate: createTimeStart || "",
          endSignDate: createTimeEnd || "",
          communityId: this.communityId,
        };

        const res = await queryContractNew(params);
        const { data, total } = res;

        this.tableData = data.map((item) => {
          return {
            partyBName: item.partyBName || "未知",
            partyBPhone: item.partyBPhone || "",
            contractTypeName:
              TEMPLATE_CODE_MAP[item.templateCode] || "未知类型",
            amount: item.totals || 0,
            signDate: item.signDate,
            startTime: item.startTime,
            endTime: item.endTime,
            marginDeposit: item.marginDeposit,
            paymentMarginDeposit: item.paymentMarginDeposit,
            paymentMarginDepositTime: item.paymentMarginDepositTime,
            policySource: item.policySource,
            policyInfo: item.policyInfo,
            moonTotals: item.moonTotals,
            totals: item.totals,
            houseArea: item.houseArea,
            houseName: item.houseName,
            contractId: item.contractId,
            state: item.state,
            rawData: item,
            invoiceStatus: item.invoiceStatus || "0",
            preInvoiceStatus: item.preInvoiceStatus || "0",
            isPayStatus: item.isPayStatus || "0",
            stampDutyStatus: item.stampDutyStatus || "0",
          };
        });

        this.pagination.total = total;
        this.multipleSelection = [];
        this.$refs.multipleTable.clearSelection();
      } catch (error) {
        // 核心改动：页面已经销毁，不再弹出提示
        if (this.componentDestroyed) {
          return;
        }
        this.$message.error("获取合同数据失败");
        console.error("获取合同列表失败：", error);
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.current = 1;
      this.fetchData();
    },

    // 重置 --- 补充：重置state退租筛选
    handleReset() {
      this.searchForm = {
        partyBName: "",
        contractId: "",
        templateCode: "",
        contractManager: "", // 重置负责人选择
        floorId: "", // 重置楼栋
        selectedHouse: "", // 重置房间号
        createTimeRange: [], // 重置时间区间
        state: "", // 重置是否退租
      };
      this.handleSearch();
    },

    // 页码大小改变
    handleSizeChange(val) {
      this.pagination.size = val;
      this.fetchData();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.fetchData();
    },

    // 打开生成合同弹窗
    openContractModal() {
      this.$refs.contractModal.open();
    },

    // 编辑合同
    async handleEdit(row) {
      try {
        this.editForm = {};
        this.editTableData = [];
        this.depositTableData = [];
        this.editLoading = true;
        const contractId = row.rawData.contractId;

        if (!contractId) {
          this.$message.warning("合同ID不存在，无法编辑");
          return;
        }

        // 调用付款详情接口
        const res = await QueryPaymentsByContractCmd({ contractId });
        // 填充付款表格数据
        this.editTableData = res.data.map((item) => ({
          ...item,
          rawData: item,
        }));

        // ========== 新增：累加所有付款租金金额作为总金额 ==========
        let sumTotal = 0;
        this.editTableData.forEach((item) => {
          if (item.rentAmount != null) {
            sumTotal += Number(item.rentAmount);
          }
        });

        // 填充基础信息
        this.editForm = {
          contractId: row.rawData.contractId || "",
          contractTypeName: row.contractTypeName || "未知类型",
          // 优先使用明细累加值，无明细再取主表totals兜底
          totalAmount:
            this.editTableData.length > 0
              ? sumTotal
              : row.rawData.totals == null
              ? 0
              : Number(row.rawData.totals),
          signDate: row.signDate || "",
          partyBName: row.partyBName || "",
          partyBPhone: row.partyBPhone || "",
          contractManager: row.rawData.contractManager || "",
        };

        this.depositTableData = [
          {
            contractId: row.rawData.contractId,
            marginDeposit: row.rawData.marginDeposit || 0,
            paymentMarginDeposit: row.rawData.paymentMarginDeposit || null,
            paymentMarginDepositTime: row.rawData.paymentMarginDepositTime || ""
          }
        ];

        console.log("累加总金额", sumTotal);
        this.editModalVisible = true;
      } catch (error) {
        this.$message.error("获取合同详情失败");
        console.error("获取合同详情失败：", error);
      } finally {
        this.editLoading = false;
      }
    },

    async handleSaveDeposit() {
      if (!this.depositTableData || this.depositTableData.length === 0) {
        this.$message.warning("暂无保证金数据");
        return;
      }
      const depositRow = this.depositTableData[0];
      try {
        this.saveDepositLoading = true;
        const params = {
          contractId: depositRow.contractId,
          paymentMarginDeposit: depositRow.paymentMarginDeposit,
          paymentMarginDepositTime: depositRow.paymentMarginDepositTime
        };
        const res = await updateContractNew(params);
        if (res.code === 0) {
          this.$message.success("保证金保存成功");
          this.fetchData();
        } else {
          this.$message.error(res.msg || "保证金保存失败");
        }
      } catch (e) {
        console.error("保存保证金异常", e);
        this.$message.error("保证金保存请求异常");
      } finally {
        this.saveDepositLoading = false;
      }
    },

    // 打开上传附件弹窗【重置文件名】
    openUploadModal(row) {
      console.log("点击上传附件，当前行数据：", row);
      console.log("合同ID：", row.rawData.contractId);

      // 重置上传数据
      this.uploadForm.contractId = row.rawData.contractId;
      this.fileList = [];
      this.uploadFilePath = "";
      this.uploadFileName = ""; // 清空文件名
      this.uploadModalVisible = true;
    },

    // 文件上传成功回调【核心修改：接收fileName保存】
    handleUploadSuccess(response, file) {
      // response.url 文件路径，file.name 原始文件名
      if (response.url) {
        this.uploadFilePath = response.url;
        this.uploadFileName = file.name; // 存储原始文件名
        this.$message.success("文件上传成功");
      } else {
        this.$message.error(response.msg || "文件上传失败");
        this.fileList = [];
        this.uploadFilePath = "";
        this.uploadFileName = "";
      }
    },

    // 文件移除回调【清空文件名】
    handleRemove(file, fileList) {
      this.uploadFilePath = "";
      this.uploadFileName = "";
      this.fileList = fileList;
    },

    // 文件超出数量限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传1个文件，你选择了${files.length + fileList.length}个文件`,
      );
    },

    // 文件上传失败
    handleUploadError(error) {
      this.$message.error("文件上传失败，请重试！");
      console.error("上传失败：", error);
    },

    // 确定上传：调用关联接口【传fileName】
    async handleConfirmUpload() {
      try {
        // 验证数据
        if (!this.uploadForm.contractId) {
          this.$message.warning("合同ID不存在，无法关联附件");
          return;
        }
        if (!this.uploadFilePath) {
          this.$message.warning("请先上传文件后再点击确定");
          return;
        }

        this.uploadConfirmLoading = true;

        // 调用附件关联接口，新增fileName参数
        const res = await uploadContractAttachmentRel({
          contractId: this.uploadForm.contractId,
          filePath: this.uploadFilePath,
          fileName: this.uploadFileName, // 传递原始文件名
        });

        if (res.code === 0) {
          this.$message.success("附件关联成功");
          this.uploadModalVisible = false;
          this.fetchData(); // 刷新列表
        } else {
          this.$message.error(res.msg || "附件关联失败");
        }
      } catch (error) {
        this.$message.error("附件关联失败，请重试");
        console.error("附件关联接口调用失败：", error);
      } finally {
        this.uploadConfirmLoading = false;
      }
    },

    // 弹窗关闭前重置数据【清空文件名】
    handleDialogClose() {
      this.fileList = [];
      this.uploadFilePath = "";
      this.uploadFileName = "";
      this.uploadConfirmLoading = false;
    },

    // 新增：导出Excel功能
    async exportExcel() {
      try {
        this.exportLoading = true;

        // 1. 解构时间区间，转换为后端能识别的参数格式
        const [createTimeStart, createTimeEnd] =
          this.searchForm.createTimeRange || [];

        // 2. 组装导出参数（新增state）
        const params = {
          partyBName: this.searchForm.partyBName,
          contractId: this.searchForm.contractId,
          templateCode: this.searchForm.templateCode,
          contractManager: this.searchForm.contractManager,
          floorId: this.searchForm.floorId,
          selectedHouse: this.searchForm.selectedHouse,
          state: this.searchForm.state,
          startSignDate: createTimeStart || "",
          endSignDate: createTimeEnd || "",
          communityId: this.communityId,
          pagePath: "newContractManage", // 可选：用于后端标识导出页面
        };

        // 3. 调用导出接口
        const res = await exportContractExcel(params);

        // 4. 处理导出结果
        if (res && res.code === 0) {
          this.$message.success("合同数据导出成功！");
          // 如果后端返回文件下载链接
          if (res.data && res.data.downloadUrl) {
            window.open(res.data.downloadUrl);
          }
          // 如果是直接返回文件流（另一种常见方式）
          else if (res instanceof Blob) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = `合同列表_${new Date().getTime()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          // 如果是跳转到下载中心（参考你的示例）
          else {
            window.open("/#/pages/property/downloadTempFile?tab=下载中心");
          }
        } else {
          this.$message.error(res.msg || "合同数据导出失败");
        }
      } catch (error) {
        console.error("导出Excel失败：", error);
        this.$message.error("导出Excel失败，请重试");
      } finally {
        this.exportLoading = false;
      }
    },

    // ======================== 新增：退租相关方法 ========================
    // 打开退租弹窗【重置退租文件名】
    openQuitRentModal(row) {
      // 重置退租表单
      this.quitRentForm = {
        contractId: row.rawData.contractId,
        quitRentDate: "",
        quitRentDesc: "",
        quitRentFilePath: "",
        quitRentFileName: "", // 重置退租附件名
      };
      this.quitRentFileList = [];
      this.quitRentConfirmLoading = false;
      this.quitRentModalVisible = true;
    },

    // 退租文件上传成功【保存文件名】
    handleQuitRentUploadSuccess(response, file) {
      if (response.url) {
        this.quitRentForm.quitRentFilePath = response.url;
        this.quitRentForm.quitRentFileName = file.name;
        this.$message.success("退租附件上传成功");
        this.$refs.quitRentFormRef.validateField("quitRentFilePath");
      } else {
        this.$message.error(response.msg || "退租附件上传失败");
        this.quitRentFileList = [];
        this.quitRentForm.quitRentFilePath = "";
        this.quitRentForm.quitRentFileName = "";
      }
    },

    // 退租文件移除【清空文件名】
    handleQuitRentRemove(file, fileList) {
      this.quitRentForm.quitRentFilePath = "";
      this.quitRentForm.quitRentFileName = "";
      this.quitRentFileList = fileList;
      // 触发校验
      this.$refs.quitRentFormRef.validateField("quitRentFilePath");
    },

    // 退租文件超出数量限制
    handleQuitRentExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传1个文件，你选择了${files.length + fileList.length}个文件`,
      );
    },

    // 退租弹窗关闭前重置【清空文件名】
    handleQuitRentDialogClose() {
      this.quitRentFileList = [];
      this.quitRentForm.quitRentFilePath = "";
      this.quitRentForm.quitRentFileName = "";
      this.quitRentConfirmLoading = false;
    },

    // 确认退租【传fileName】
    async handleConfirmQuitRent() {
      try {
        // 表单验证
        await this.$refs.quitRentFormRef.validate();

        // 基础验证
        if (!this.quitRentForm.contractId) {
          this.$message.warning("合同ID不存在，无法办理退租");
          return;
        }

        this.quitRentConfirmLoading = true;

        // 组装退租请求参数，携带文件名
        const params = {
          contractId: this.quitRentForm.contractId,
          quitRentDate: this.quitRentForm.quitRentDate,
          quitRentDesc: this.quitRentForm.quitRentDesc || "",
          quitRentFilePath: this.quitRentForm.quitRentFilePath || "",
          quitRentFileName: this.quitRentForm.quitRentFileName || "",
          communityId: this.communityId,
        };

        // 调用退租接口
        const res = await quitRentContract(params);

        if (res.code === 0) {
          this.$message.success("退租办理成功！");
          this.quitRentModalVisible = false;
          this.fetchData(); // 刷新合同列表
        } else {
          this.$message.error(res.msg || "退租办理失败");
        }
      } catch (error) {
        if (error.name !== "ValidationError") {
          console.error("退租办理失败：", error);
          this.$message.error("退租办理失败，请重试");
        }
      } finally {
        this.quitRentConfirmLoading = false;
      }
    },

    // ====================== 新增：3个Switch 弹窗确认 + 调用接口 ======================
    // 1. 是否开具发票
    // 1. 是否开具发票
    handleInvoiceChange(row) {
      const oldVal = row.invoiceStatus;
      const newVal = oldVal === "1" ? "0" : "1";
      const txt = newVal === "1" ? "已开具" : "未开具";
      this.$confirm(`确认将该条付款记录设为【${txt}】？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          row.invoiceStatus = newVal;
          await this.updateInvoiceStatus(row);
        })
        .catch(() => {
          // 取消，不做任何赋值，UI保持原样
        });
    },
    // 2. 是否预开发票
    handlePreInvoiceChange(row) {
      const oldVal = row.preInvoiceStatus;
      const newVal = oldVal === "1" ? "0" : "1";
      const txt = newVal === "1" ? "已预开" : "未预开";
      this.$confirm(`确认将该条付款记录设为【${txt}】？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          row.preInvoiceStatus = newVal;
          await this.updatePreInvoiceStatus(row);
        })
        .catch(() => {});
    },
    // 3. 是否上缴
    handlePayStatusChange(row) {
      const oldVal = row.isPayStatus;
      const newVal = oldVal === "1" ? "0" : "1";
      const txt = newVal === "1" ? "已上缴" : "未上缴";
      this.$confirm(`确认将该条付款记录设为【${txt}】？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          row.isPayStatus = newVal;
          await this.updatePayStatus(row);
        })
        .catch(() => {});
    },
    // 4. 是否开具印花税（列表行）
    handlestampDutyStatusChange(row) {
      const oldVal = row.stampDutyStatus;
      const newVal = oldVal === "1" ? "0" : "1";
      const txt = newVal === "1" ? "已开具" : "未开具";
      this.$confirm(`确认将合同【${row.contractId}】设为【${txt}】？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          row.stampDutyStatus = newVal;
          await this.updateStampDutyStatus(row);
        })
        .catch(() => {});
    },

    // ====== 下面三个是真实接口调用（你只需要替换接口名即可）======
    async updateInvoiceStatus(row) {
      const oldVal = row.invoiceStatus;
      try {
        await updatePaymentsByContract({
          paymentId: row.paymentId,
          invoiceStatus: row.invoiceStatus,
        });
        this.$message.success("设置成功");
      } catch (e) {
        // 接口异常，回滚
        row.invoiceStatus = oldVal;
        this.$message.error("设置失败");
      }
    },
    async updatePreInvoiceStatus(row) {
      const oldVal = row.preInvoiceStatus;
      try {
        await updatePaymentsByContract({
          paymentId: row.paymentId,
          preInvoiceStatus: row.preInvoiceStatus,
        });
        this.$message.success("设置成功");
      } catch (e) {
        row.preInvoiceStatus = oldVal;
        this.$message.error("设置失败");
      }
    },
    async updatePayStatus(row) {
      const oldVal = row.isPayStatus;
      try {
        await updatePaymentsByContract({
          paymentId: row.paymentId,
          isPayStatus: row.isPayStatus,
        });
        this.$message.success("设置成功");
      } catch (e) {
        row.isPayStatus = oldVal;
        this.$message.error("设置失败");
      }
    },
    async updateStampDutyStatus(row) {
      const oldVal = row.stampDutyStatus;
      try {
        await updateContractNew({
          contractId: row.contractId,
          stampDutyStatus: row.stampDutyStatus,
        });
        this.$message.success("设置成功");
      } catch (e) {
        row.stampDutyStatus = oldVal;
        this.$message.error("设置失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.new-contract-manage-container {
  padding: 20px;
  .search-card {
    margin-bottom: 20px;
  }
  .table-card {
    margin-bottom: 20px;
  }
  .note-text {
    margin: 15px 0;
    color: #999;
    font-size: 14px;
  }
  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
  .upload-demo {
    margin: 20px 0;
  }
  .edit-base-card {
    .info-item {
      margin-bottom: 10px;
      font-size: 14px;
      .label {
        color: #666;
        font-weight: 500;
        margin-right: 8px;
      }
      .value {
        color: #333;
      }
    }
  }
  .edit-table-card {
    .el-table {
      --el-table-header-text-color: #333;
      --el-table-row-hover-bg-color: #f5f7fa;
    }
  }
  .dialog-footer {
    text-align: right;
  }
  .house-name-text {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    color: #409eff;
    &:hover {
      color: #66b1ff;
      text-decoration: underline;
    }
  }
  .house-name-content {
    padding: 10px;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
</style>
